// extracted by mini-css-extract-plugin
export default {"container":"EtPrtp","active":"yXi206","placeholder-shimmer":"KYZzRt","placeholderShimmer":"KYZzRt","universal":"dZ06L2","dark":"uEx1Wc","light":"AQf7w0"};